import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  CircularProgress,
  Button,
  Card,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import { CloudUpload } from "@mui/icons-material";
import { showAlert } from "../actions/alert";
import { getFormattedFile } from "../api/activity";
import download from "downloadjs";
import { handleAxiosError } from "../config/action-config";

export default function ItemDialogUploadDoc({
  activityType,
  open,
  setOpen,
  onSubmit,
}) {
  const [data, setData] = useState();
  const [loader, setLoader] = useState(false);
  const [selectedFile, setSelectedFile] = useState("");
  const [isSelected, setIsSelected] = useState(false);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };
  const getExcelViewerData = () => {
    console.log(activityType);
    return getFormattedFile({ activityfile: activityType }, user.token)
      .then((res) => {
        if (res) {
          download(
            res.data,
            activityType === "y"
              ? "Activity_Sample_file.csv"
              : "Recurring_Activity_Sample_file.csv"
          );
        } else {
          alert("Data not found");
        }
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
      });
  };
  const submit = () => {
    const formData = new FormData();
    if (selectedFile == "") {
      setOpen("UPLOAD_EXCEL");
      return dispatch(showAlert("Attachment can't be empty"));
    }
    const appenddata = formData.append("myFiledoc", selectedFile);
    if (/\.(xlsx|csv)$/.test(selectedFile.name)) {
      setLoader(true);
      onSubmit(formData).then(() => {
        setLoader(false);
        setIsSelected(false);
        setSelectedFile("");
      });
    } else {
      setSelectedFile("");
      setOpen("UPLOAD_EXCEL");
      return dispatch(showAlert("Please upload xlsx file."));
    }
  };

  const changeHandler = (event) => {
    setSelectedFile(event.target.files[0]);
    setIsSelected(true);
  };

  return (
    <Dialog
      open={open}
      onClose={() => {
        //  setOpen("ATTACHMENTS_TAB");
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title" sx={{ textTransform: "capitalize" }}>
        Attachments
      </DialogTitle>
      <DialogContent>
        <Grid container width={500} spacing={1} py={1}>
          <Grid item xs={12} md={12}>
            <Card sx={{ boxShadow: "none !important" }}>
              <div class="upload-files-container">
                <div class="drag-file-area">
                  <Button className="blue-button" onClick={getExcelViewerData}>
                    {"Sample File"}
                  </Button>
                  <div class="upload-icon">
                    <CloudUpload sx={{ fontSize: 40, color: "#08459c" }} />
                  </div>
                  <h6 class="dynamic-message"> Drag & drop any file here </h6>
                  <div class="browse-files">
                    <input
                      className="file-upload"
                      type="file"
                      name="file"
                      onChange={changeHandler}
                    />
                    {isSelected ? (
                      <Box>
                        <Typography>Filename: {selectedFile.name}</Typography>
                        <Typography>Filetype: {selectedFile.type}</Typography>
                        <Typography>
                          Size in bytes: {selectedFile.size}
                        </Typography>
                        <Typography>
                          Last Modified Date:
                          {new Date(
                            selectedFile.lastModified
                          ).toLocaleDateString()}
                        </Typography>
                      </Box>
                    ) : (
                      <Typography>Select a file to show details</Typography>
                    )}
                  </div>
                </div>
              </div>
            </Card>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          className="cancel-button"
          onClick={() => {
            setOpen("UPLOAD_EXCEL");
            setIsSelected(false);
            setSelectedFile("");
          }}
        >
          Cancel
        </Button>
        {loader === false ? (
          <Button
            disabled={/^Trial_User$/i.test(user.role) ? true : false}
            className="blue-button"
            onClick={submit}
          >
            {"Add Attachments"}
          </Button>
        ) : (
          <Box sx={{ display: "flex" }}>
            <CircularProgress />
          </Box>
        )}
      </DialogActions>
    </Dialog>
  );
}
